import { Link } from 'react-router-dom';
import { stories } from '@/mocks/stories';
import StoryCard from '@/components/base/StoryCard';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

const sorted = [...stories].sort((a, b) => b.heat - a.heat);
const top = sorted[0];
const rest = sorted.slice(1, 7);

const formatHeat = (value: number) =>
  value >= 10000 ? `${(value / 10000).toFixed(1)} 万` : value.toLocaleString('zh-CN');

export default function HotSection() {
  return (
    <section id="hot" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            kicker="今日热瓜"
            title="讨论量最高的七条线索"
            desc="按当日公开讨论量排序，只收录能追到来源的事件；热度会随进展实时调整。"
          />
          <Link
            to="/category/event-track"
            className="cursor-pointer whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
          >
            查看全部事件追踪 →
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <article className="group h-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <Link to={`/melon/${top.id}`} className="block aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={top.cover}
                  alt={`${top.title} 配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </Link>
              <div className="p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                    <i className="ri-fire-line" />
                    热度 {formatHeat(top.heat)}
                  </span>
                  <span className="rounded-full border border-background-300 px-3 py-1 text-xs text-foreground-600">
                    {top.category}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                  <Link to={`/melon/${top.id}`} className="hover:text-primary-700">
                    {top.title}
                  </Link>
                </h3>
                <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">{top.excerpt}</p>
                <p className="mt-4 flex items-start gap-2 rounded-md bg-accent-100 p-3 text-xs leading-relaxed text-accent-900">
                  <i className="ri-question-answer-line mt-0.5" />
                  {top.verdict}
                </p>
              </div>
            </article>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={120}>
            <div className="h-full rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-list-ordered text-primary-600" />
                热度榜紧随其后
              </h3>
              <div className="mt-2">
                {rest.map((story) => (
                  <StoryCard key={story.id} story={story} variant="row" />
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}